module.exports = __webpack_public_path__ + "img/sec-292-kape.2fef52fd.svg";